import { bl_fi_stmt_account_event_hdr_RowClass } from '../../../dbschema/bl_fi_stmt_account_event_hdr.model';
import { BaseContainerModel } from '../../base-container.model';

export class StatementOfAccountEventHdrModel extends BaseContainerModel {
  bl_fi_stmt_account_event_hdr: bl_fi_stmt_account_event_hdr_RowClass = new bl_fi_stmt_account_event_hdr_RowClass();
}